"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnMovingCell = void 0;
const react_1 = __importStar(require("react"));
const ColumnMovingCell_styles_1 = require("./ColumnMovingCell.styles");
const ColumnInsertDetector_1 = require("../../helpers/ColumnInsertDetector");
const START_MOVING_OFFSET = 5;
const START_MOVING_TIMEOUT = 400;
exports.ColumnMovingCell = (0, react_1.memo)((props) => {
    const wrapperRef = (0, react_1.useRef)(null);
    const draggingOverlayRef = (0, react_1.useRef)(null);
    const [isMoving, setIsMoving] = (0, react_1.useState)(false);
    const isMovingRef = (0, react_1.useRef)(false);
    const [self] = (0, react_1.useState)(() => ({
        startDragClientX: 0,
        startDraggingTimer: 0,
        removeListenersCallbacks: [],
        columnInsertDetector: new ColumnInsertDetector_1.ColumnInsertDetector()
    }));
    const startMoving = (0, react_1.useCallback)((movingClientXOffset, nextClientX) => {
        isMovingRef.current = true;
        setIsMoving(true);
        document.documentElement.style.cursor = 'grabbing';
        requestAnimationFrame(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            try {
                (_b = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty) === null || _b === void 0 ? void 0 : _b.call(_a);
                (_d = (_c = window.getSelection()) === null || _c === void 0 ? void 0 : _c.removeAllRanges) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            catch (_l) { }
            (_f = (_e = draggingOverlayRef.current) === null || _e === void 0 ? void 0 : _e.style) === null || _f === void 0 ? void 0 : _f.setProperty('transform', `translateX(${movingClientXOffset}px)`);
            self.columnInsertDetector.capture({ currentClientX: nextClientX });
            const { columnIndexChanged, insertPositionOffset } = self.columnInsertDetector.getValue();
            if (columnIndexChanged) {
                (_h = (_g = props.rootRef.current) === null || _g === void 0 ? void 0 : _g.style) === null || _h === void 0 ? void 0 : _h.setProperty('--grid-core-col-moving-indicator-left-position', `${insertPositionOffset}px`);
            }
            (_k = (_j = props.rootRef.current) === null || _j === void 0 ? void 0 : _j.style) === null || _k === void 0 ? void 0 : _k.setProperty('--grid-core-col-moving-indicator-display', columnIndexChanged ? 'block' : 'none');
        });
    }, [props.rootRef, self.columnInsertDetector]);
    const stopMoving = (0, react_1.useCallback)(() => {
        isMovingRef.current = false;
        setIsMoving(false);
        document.documentElement.style.cursor = '';
        window.clearTimeout(self.startDraggingTimer);
        self.startDragClientX = 0;
        self.columnInsertDetector.stop();
        self.removeListenersCallbacks.forEach((cb) => cb());
        self.removeListenersCallbacks = [];
        requestAnimationFrame(() => {
            var _a, _b;
            (_b = (_a = props.rootRef.current) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty('--grid-core-col-moving-indicator-display', 'none');
        });
    }, [props.rootRef, self]);
    const submitMoving = (0, react_1.useCallback)(() => {
        var _a;
        const { columnIndexChanged, prevColumnIndex, nextColumnIndex } = self.columnInsertDetector.getValue();
        if (columnIndexChanged) {
            (_a = props.onColumnOrderChange) === null || _a === void 0 ? void 0 : _a.call(props, {
                prevColumnIndex,
                nextColumnIndex
            });
        }
        stopMoving();
    }, [self.columnInsertDetector, stopMoving, props]);
    const handleMouseMove = (0, react_1.useCallback)((e) => {
        const nextClientX = e.clientX;
        const movingClientXOffset = nextClientX - self.startDragClientX;
        if (movingClientXOffset > START_MOVING_OFFSET ||
            movingClientXOffset < -START_MOVING_OFFSET ||
            isMovingRef.current) {
            startMoving(movingClientXOffset, nextClientX);
        }
    }, [self.startDragClientX, startMoving]);
    const enableReorderOnTimeout = (0, react_1.useCallback)((e) => {
        startMoving(0, e.clientX);
    }, [startMoving]);
    const handleMouseUp = (0, react_1.useCallback)(() => {
        submitMoving();
    }, [submitMoving]);
    const handleMouseDown = (0, react_1.useCallback)((e) => {
        self.startDragClientX = e.clientX;
        self.columnInsertDetector.start({
            rootHTMLElement: props.rootRef.current,
            bodyHtmlElement: props.bodyRef.current,
            columnsWidths: props.columnsGetter(),
            currentClientX: e.clientX
        });
        self.startDraggingTimer = window.setTimeout(() => {
            if (!isMovingRef.current) {
                enableReorderOnTimeout(e);
            }
        }, START_MOVING_TIMEOUT);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp, true);
        document.addEventListener('contextmenu', stopMoving);
        document.addEventListener('keydown', stopMoving);
        self.removeListenersCallbacks.push(() => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp, true);
            document.removeEventListener('contextmenu', stopMoving);
            document.removeEventListener('keydown', stopMoving);
        });
    }, [self, props, handleMouseMove, handleMouseUp, stopMoving, enableReorderOnTimeout]);
    return (react_1.default.createElement(ColumnMovingCell_styles_1.StyledColumnMovingCell, { ref: wrapperRef, onMouseDown: handleMouseDown, "data-selector-id": "column-moving-cell", className: "vm-ColumnMovingCell" },
        props.content,
        isMoving && (react_1.default.createElement(ColumnMovingCell_styles_1.StyledColumnMovingCellReorderGhost, { ref: draggingOverlayRef, "data-selector-id": "column-moving-cell-reorder-ghost", className: "vm-ColumnMovingCellReorderGhost" }))));
});
//# sourceMappingURL=ColumnMovingCell.js.map